const STAGES = [
  { key: "recap", label: "Recap" },
  { key: "warmup", label: "Warm Up" },
  { key: "practice", label: "Practice" },
];

export default function TryProgressIndicator({ stage }) {
  const activeIndex = STAGES.findIndex((s) => s.key === stage);
  const isComplete = stage === "complete";

  return (
    <div className="flex items-center gap-2" data-testid="try-progress-indicator">
      {STAGES.map((s, i) => {
        const isActive = s.key === stage;
        const isDone = isComplete || activeIndex > i;
        return (
          <div key={s.key} className="flex items-center gap-2 flex-1">
            <div
              className={`flex-1 text-center py-2 rounded-full text-xs font-semibold uppercase tracking-wide transition-colors ${
                isActive ? "bg-sky-500 text-white" : isDone ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-400"
              }`}
              data-testid={`try-progress-stage-${s.key}`}
            >
              {s.label}
            </div>
            {i < STAGES.length - 1 && (
              <div className={`w-4 h-0.5 shrink-0 ${isDone ? "bg-emerald-300" : "bg-slate-200"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
